export default "__VITE_ASSET__CsF4iauW__"